import React from 'react'
import { connect } from 'react-redux'
import { signOut, createNewCompanyAccount } from '../../actions/AuthActions'
import UserCreateNewCompanyAccountForm from '../../components/auth/UserCreateNewCompanyAccountForm'
import SiteLayout from '../../containers/layout/SiteLayout'
import HelmetTitle from '../../components/layout/HelmetTitle'

class UserCreateNewCompanyAccount extends React.Component {

  handleSubmit = ({ companyName }) => {
    this.props.dispatch(createNewCompanyAccount({
      company_name: companyName,
    }))
  }

  renderBody = (props,state) => <SiteLayout apiAuth={props.apiAuth}>
    <HelmetTitle title={'Create New Company Account'} />
    <UserCreateNewCompanyAccountForm
      apiAuth={props.apiAuth}
      dispatch={props.dispatch}
      submitHandler={this.handleSubmit}
    />
  </SiteLayout>

  render = () => this.renderBody(this.props,this.state)

}

export default connect(
  (store, props) => ({
    apiAuth: store.apiAuth,
    router: store.router,
  }),
)(UserCreateNewCompanyAccount)
